import { render, staticRenderFns } from "./defaulfooter.vue?vue&type=template&id=e2d54fe4&"
import script from "./defaulfooter.vue?vue&type=script&lang=js&"
export * from "./defaulfooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports